import RecaptchaLoader from '../utils/recaptcha-loader.js';

const MailForm = {
	init() {
		const form = document.querySelector("#mail-form");
		const responseBox = document.querySelector("#mail-form-response");

		if (!form || !responseBox) {
			return;
		}

		// Load reCAPTCHA when user starts interacting with the form
		const inputs = form.querySelectorAll('input, textarea');
		let recaptchaLoaded = false;

		const loadRecaptchaOnInteraction = () => {
			if (!recaptchaLoaded) {
				recaptchaLoaded = true;
				RecaptchaLoader.load().catch(error => {
					// Silent error handling for production
				});
				
				// Remove listeners after loading
				inputs.forEach((input, inputIndex) => {
					input.removeEventListener('focus', loadRecaptchaOnInteraction);
					input.removeEventListener('input', loadRecaptchaOnInteraction);
				});
			}
		};

		// Add listeners to trigger reCAPTCHA loading
		inputs.forEach((input, inputIndex) => {
			input.addEventListener('focus', loadRecaptchaOnInteraction);
			input.addEventListener('input', loadRecaptchaOnInteraction);
		});

		form.addEventListener("submit", async (e) => {
			e.preventDefault();
			responseBox.innerHTML = "";
			responseBox.className = "form-response-message";

			try {
				const token = await RecaptchaLoader.execute("mail_form");

				const formData = new FormData();
				formData.append("action", "send_mail_form");
				formData.append("nonce", mailFormData.nonce);
				formData.append("g-recaptcha-response", token);

				const inputs = form.querySelectorAll("[name]");

				inputs.forEach((input, inputIndex) => {
					let value;

					if (input.type === "checkbox") {
						value = input.checked ? "Áno" : "Nie";
					} else {
						value = input.value;
					}

					const name = input.name;
					const label = input.dataset.label || name;

					formData.append(name, value);
					formData.append(`${name}_label`, label);
				});

				const response = await fetch(mailFormData.ajax_url, {
					method: "POST",
					body: formData,
				});

				const result = await response.json();

				if (result.success) {
					form.reset();
					responseBox.innerHTML = "Správa bola úspešne odoslaná.";
					responseBox.classList.add("form-response-success");
				} else {
					responseBox.innerHTML = "Chyba: " + (result?.data?.message || "Nepodarilo sa odoslať správu.");
					responseBox.classList.add("form-response-error");
				}
			} catch (error) {
				responseBox.innerHTML = "Nastala neočakávaná chyba.";
				responseBox.classList.add("form-response-error");
			}
		});
	}
};

export default MailForm;

document.addEventListener("DOMContentLoaded", () => {
  MailForm.init();
});